import { render, staticRenderFns } from "./TextSelection.vue?vue&type=template&id=17bb339e&scoped=true"
import script from "./TextSelection.vue?vue&type=script&lang=js"
export * from "./TextSelection.vue?vue&type=script&lang=js"
import style0 from "./TextSelection.vue?vue&type=style&index=0&id=17bb339e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bb339e",
  null
  
)

export default component.exports